import { lazy } from 'react';

// project import
import Loadable from 'components/@ui/loader/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import { Navigate } from 'react-router-dom';
import NFCApp from './nfc/NFC';

// render - login
const Offers = Loadable(lazy(() => import('pages/public/offers/Offers')));
const Offer = Loadable(lazy(() => import('pages/public/offer/Offer')));
const ResetPassword = Loadable(lazy(() => import('pages/authentication/auth-forms/ResetPassword')));

// ==============================|| AUTH ROUTING ||============================== //

const PublicRoutes = {
  path: '/public',
  element: <MinimalLayout />,
  children: [
    {
      path: 'offers',
      element: <Offers />
    },
    {
      path: 'offers/:offerId',
      element: <Offer />
    },
    {
      path: 'reset/password/:passkey',
      element: <ResetPassword />
    }
  ]
};

export default PublicRoutes;
